module.exports = __webpack_public_path__ + "static/media/veterinary.be351515.png";